import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import {QuoteStatusChangeNotificationDataApiDto} from "../../../api/model/rest";
import {option, Option} from "ts-option";

/**
 * Quote status changed notification class data.
 */
export default class QuoteStatusChangedNotificationData {
	/**
	 * @param leadId
	 * @param leadReferenceNumber
	 * @param entity
	 * @param quoteId
	 * @param status
	 * @param prevStatus
	 * @param statusComment
	 */
	constructor(readonly leadId: string,
		readonly leadReferenceNumber: string,
		readonly entity: AuthenticatedEntity,
		readonly quoteId: string,
		readonly status: string,
		readonly prevStatus: string,
		readonly statusComment: Option<string>) {}

	static fromJson(json: QuoteStatusChangeNotificationDataApiDto): QuoteStatusChangedNotificationData {
		const updater = AuthenticatedEntity.fromJson(json.updater);
		return new QuoteStatusChangedNotificationData(
			json.leadId,
			json.leadReferenceNumber,
			updater,
			json.quoteId,
			json.status,
			json.prevStatus,
			option(json.statusComment));
	}
}
